import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
};

/** Autogenerated return type of AcknowledgePolicy. */
export type AcknowledgePolicyPayload = {
  __typename?: 'AcknowledgePolicyPayload';
  errors: Array<Scalars['String']>;
  learnerTraining?: Maybe<LearnerTraining>;
};

/** Audio (medium) */
export type Audio = {
  __typename?: 'Audio';
  autoPlay?: Maybe<Scalars['Boolean']>;
  generated: Scalars['Boolean'];
  id: Scalars['ID'];
  loop?: Maybe<Scalars['Boolean']>;
  mediaUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subtitlesUrl?: Maybe<Scalars['String']>;
};

/** Sequence item of type background */
export type Background = ItemInterface & {
  __typename?: 'Background';
  appear?: Maybe<Scalars['Float']>;
  audios?: Maybe<Array<Audio>>;
  backgroundType?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mediaOrientation?: Maybe<Scalars['String']>;
  opacity?: Maybe<Scalars['Int']>;
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<VideoMedium>>;
};

/** Sequence item of type button */
export type Button = ItemInterface & {
  __typename?: 'Button';
  appear?: Maybe<Scalars['Float']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

/** Sequence item of type card */
export type Card = ItemInterface & {
  __typename?: 'Card';
  appear?: Maybe<Scalars['Float']>;
  audios?: Maybe<Array<Audio>>;
  body?: Maybe<Scalars['String']>;
  branchSequenceId?: Maybe<Scalars['String']>;
  disappear?: Maybe<Scalars['Float']>;
  documents?: Maybe<Array<Document>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<Button>>;
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<VideoMedium>>;
};

/** Sequence item of type carousel */
export type Carousel = ItemInterface & {
  __typename?: 'Carousel';
  appear?: Maybe<Scalars['Float']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

/** A training contains multiple chapters with sequences in each of them */
export type Chapter = {
  __typename?: 'Chapter';
  chapterSequences: Array<ChapterSequence>;
  duration: Scalars['Int'];
  id: Scalars['ID'];
  position: Scalars['Int'];
  title: Scalars['String'];
};

/** To link a sequence inside a chapter */
export type ChapterSequence = {
  __typename?: 'ChapterSequence';
  chapterId: Scalars['ID'];
  duration: Scalars['Int'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parentId?: Maybe<Scalars['ID']>;
  position?: Maybe<Scalars['Int']>;
  sequenceId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Sequence item of type chart */
export type Chart = ItemInterface & {
  __typename?: 'Chart';
  appear?: Maybe<Scalars['Float']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

/** Sequence item of type ChatBot */
export type ChatBot = ItemInterface & {
  __typename?: 'ChatBot';
  appear?: Maybe<Scalars['Float']>;
  audios?: Maybe<Array<Audio>>;
  body?: Maybe<Scalars['String']>;
  conversationBotId?: Maybe<Scalars['ID']>;
  disappear?: Maybe<Scalars['Float']>;
  documents?: Maybe<Array<Document>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<VideoMedium>>;
  voiceEnabled?: Maybe<Scalars['Boolean']>;
};

export type ChatbotMessage = {
  __typename?: 'ChatbotMessage';
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  role?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of Comment. */
export type CommentPayload = {
  __typename?: 'CommentPayload';
  errors: Array<Scalars['String']>;
};

/** A company is a client */
export type Company = {
  __typename?: 'Company';
  brandColorDark?: Maybe<Scalars['String']>;
  brandColorLight?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  feedbackUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  legalName?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Returns company point-of-contacts */
export type CompanyContact = {
  __typename?: 'CompanyContact';
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  otherInfo?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CompleteChapterSequence. */
export type CompleteChapterSequencePayload = {
  __typename?: 'CompleteChapterSequencePayload';
  errors: Array<Scalars['String']>;
  learnerTraining?: Maybe<LearnerTraining>;
  richErrors?: Maybe<Array<RichError>>;
};

/** Document (medium) */
export type Document = {
  __typename?: 'Document';
  id: Scalars['ID'];
  mediaUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Sequence item of type door */
export type Door = ItemInterface & {
  __typename?: 'Door';
  appear?: Maybe<Scalars['Float']>;
  audios?: Maybe<Array<Audio>>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<Card>>;
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<VideoMedium>>;
};

/** Sequence item of type select dropdown */
export type Dropdown = ItemInterface & {
  __typename?: 'Dropdown';
  appear?: Maybe<Scalars['Float']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** Sequence item of type email */
export type Email = ItemInterface & {
  __typename?: 'Email';
  appear?: Maybe<Scalars['Float']>;
  audios?: Maybe<Array<Audio>>;
  body?: Maybe<Scalars['String']>;
  disappear?: Maybe<Scalars['Float']>;
  documents?: Maybe<Array<Document>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

/** Sequence item of type flip card */
export type FlipCard = ItemInterface & {
  __typename?: 'FlipCard';
  appear?: Maybe<Scalars['Float']>;
  body?: Maybe<Scalars['String']>;
  correct?: Maybe<Scalars['Boolean']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  picture?: Maybe<Picture>;
  position?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

/** Sequence item of type image map */
export type ImageMap = ItemInterface & {
  __typename?: 'ImageMap';
  appear?: Maybe<Scalars['Float']>;
  disappear?: Maybe<Scalars['Float']>;
  hotspotPlacementVersion?: Maybe<Scalars['Int']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<Popup>>;
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

/** An item that belongs to a Sequence */
export type ItemInterface = {
  appear?: Maybe<Scalars['Float']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** Sequence item of type Layout */
export type Layout = ItemInterface & {
  __typename?: 'Layout';
  appear?: Maybe<Scalars['Float']>;
  body?: Maybe<Scalars['String']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<Text>>;
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

/** A learner is a user taking the training */
export type Learner = {
  __typename?: 'Learner';
  company: Company;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  manager?: Maybe<Learner>;
  middleName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** To track a learner taking a training */
export type LearnerTraining = {
  __typename?: 'LearnerTraining';
  askName?: Maybe<Scalars['Boolean']>;
  /** Attempts allowed under the company attempt limit; null while attempts are unlimited */
  attemptLimit?: Maybe<Scalars['Int']>;
  attemptStatus?: Maybe<Scalars['String']>;
  /** Attempts left under the company attempt limit; null while attempts are unlimited */
  attemptsRemaining?: Maybe<Scalars['Int']>;
  auditoryFeedback?: Maybe<Scalars['Boolean']>;
  autoPlay?: Maybe<Scalars['Boolean']>;
  autoSaveVideoWatchedSecondsIntervalInSeconds?: Maybe<Scalars['Int']>;
  certificateUrl?: Maybe<Scalars['String']>;
  chapterSequenceId?: Maybe<Scalars['ID']>;
  chatGreeting?: Maybe<Scalars['String']>;
  chatQuestions?: Maybe<Array<Scalars['String']>>;
  chatbotChannel?: Maybe<Scalars['String']>;
  chatbotMessages?: Maybe<Array<ChatbotMessage>>;
  companyContacts?: Maybe<Array<CompanyContact>>;
  darkMode?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['ISO8601Date']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']>;
  fasterPlaybackSpeed?: Maybe<Scalars['Boolean']>;
  featureFocus?: Maybe<Scalars['Boolean']>;
  featureShowAbout?: Maybe<Scalars['Boolean']>;
  featureShowCertificate?: Maybe<Scalars['Boolean']>;
  featureShowChatbot?: Maybe<Scalars['Boolean']>;
  featureShowHomeButton?: Maybe<Scalars['Boolean']>;
  featureShowHotline?: Maybe<Scalars['Boolean']>;
  featureShowIssueReporting?: Maybe<Scalars['Boolean']>;
  featureShowLlama?: Maybe<Scalars['Boolean']>;
  featureShowNextTraining?: Maybe<Scalars['Boolean']>;
  featureShowReviewStep?: Maybe<Scalars['Boolean']>;
  featureShowSocialShare?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lastAttemptScorePercent?: Maybe<Scalars['Int']>;
  learnerPortalUrl?: Maybe<Scalars['String']>;
  mediumLocale?: Maybe<Scalars['String']>;
  messages?: Maybe<Scalars['JSON']>;
  onboarding?: Maybe<Scalars['Boolean']>;
  playbackSpeed: Scalars['Float'];
  player?: Maybe<Scalars['String']>;
  policies?: Maybe<Array<Policy>>;
  policiesForSignature?: Maybe<Array<Policy>>;
  policyAcknowledgement?: Maybe<Scalars['Boolean']>;
  policyAcknowledgementSignature?: Maybe<Scalars['Boolean']>;
  progress?: Maybe<Scalars['Int']>;
  promptOptions?: Maybe<Scalars['JSON']>;
  promptProfile?: Maybe<Scalars['Boolean']>;
  remainingDurationInMinutes?: Maybe<Scalars['Int']>;
  remainingDurationInMinutesForCourseTimers?: Maybe<Scalars['Int']>;
  remainingDurationInSecondsForCourseTimers?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['Int']>;
  scoreMax?: Maybe<Scalars['Int']>;
  scorePassingPercent?: Maybe<Scalars['Float']>;
  scorePercent?: Maybe<Scalars['Int']>;
  shouldDisplayCourseDurationCard?: Maybe<Scalars['Boolean']>;
  shouldDisplayTimeRemainingPill?: Maybe<Scalars['Boolean']>;
  shouldDisplayTimerStillRunningModal?: Maybe<Scalars['Boolean']>;
  shouldSaveVideoWatchedSeconds?: Maybe<Scalars['Boolean']>;
  showDemoBanner?: Maybe<Scalars['Boolean']>;
  skip?: Maybe<Scalars['Boolean']>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']>;
  status: LearnerTrainingStatus;
  subtitleLocale?: Maybe<Scalars['String']>;
  subtitles?: Maybe<Scalars['Boolean']>;
  textLocale?: Maybe<Scalars['String']>;
  training: Training;
  viewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  visualFeedback?: Maybe<Scalars['Boolean']>;
};

/** LearnerTraining status */
export enum LearnerTrainingStatus {
  Activated = 'activated',
  Completed = 'completed',
  InProgress = 'in_progress',
  Unassigned = 'unassigned'
}

/** Video playback progress record for a specific video item in a sequence */
export type LearnerTrainingVideoRecord = {
  __typename?: 'LearnerTrainingVideoRecord';
  id: Scalars['ID'];
  learnerTrainingId: Scalars['ID'];
  sequenceId: Scalars['ID'];
  videoId: Scalars['ID'];
  watchedSeconds: Scalars['Int'];
};

/** Sequence item of type list (bullet points, etc.) */
export type List = ItemInterface & {
  __typename?: 'List';
  appear?: Maybe<Scalars['Float']>;
  body?: Maybe<Scalars['String']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<Text>>;
  position?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

/** Sequence item of type message */
export type Message = ItemInterface & {
  __typename?: 'Message';
  appear?: Maybe<Scalars['Float']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
  sender?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of MessageChatbot. */
export type MessageChatbotPayload = {
  __typename?: 'MessageChatbotPayload';
  chatbotMessages?: Maybe<Array<ChatbotMessage>>;
  errors: Array<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgePolicy?: Maybe<AcknowledgePolicyPayload>;
  comment?: Maybe<CommentPayload>;
  completeChapterSequence?: Maybe<CompleteChapterSequencePayload>;
  messageChatbot?: Maybe<MessageChatbotPayload>;
  processChatbotMessage?: Maybe<ProcessChatbotMessagePayload>;
  recordReviewTime?: Maybe<RecordReviewTimePayload>;
  review?: Maybe<ReviewPayload>;
  saveAnswers?: Maybe<SaveAnswersPayload>;
  updateName?: Maybe<UpdateNamePayload>;
  updateProfile?: Maybe<UpdateProfilePayload>;
  updateSettings?: Maybe<UpdateSettingsPayload>;
  updateVideoRecord?: Maybe<UpdateVideoRecordPayload>;
};


export type MutationAcknowledgePolicyArgs = {
  learnerTrainingUuid: Scalars['ID'];
  policyIds: Array<Scalars['ID']>;
  signature?: InputMaybe<Scalars['String']>;
};


export type MutationCommentArgs = {
  chapterSequenceId?: InputMaybe<Scalars['ID']>;
  learnerTrainingUuid: Scalars['ID'];
  question?: InputMaybe<Scalars['String']>;
  recipient: Scalars['String'];
  topic?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
};


export type MutationCompleteChapterSequenceArgs = {
  chapterSequenceId: Scalars['ID'];
  learnerTrainingUuid: Scalars['ID'];
};


export type MutationMessageChatbotArgs = {
  id: Scalars['ID'];
  message: Scalars['String'];
};


export type MutationProcessChatbotMessageArgs = {
  id?: InputMaybe<Scalars['ID']>;
  learnerTrainingUuid?: InputMaybe<Scalars['ID']>;
  message: Scalars['String'];
};


export type MutationRecordReviewTimeArgs = {
  active: Scalars['Boolean'];
  learnerTrainingUuid: Scalars['ID'];
  reset?: InputMaybe<Scalars['Boolean']>;
};


export type MutationReviewArgs = {
  comment?: InputMaybe<Scalars['String']>;
  learnerTrainingUuid: Scalars['ID'];
  rating?: InputMaybe<Scalars['Int']>;
  ratingContent?: InputMaybe<Scalars['Int']>;
  ratingEngagement?: InputMaybe<Scalars['Int']>;
  ratingFunctionality?: InputMaybe<Scalars['Int']>;
};


export type MutationSaveAnswersArgs = {
  chapterSequenceId: Scalars['ID'];
  correct?: InputMaybe<Scalars['Boolean']>;
  learnerTrainingUuid: Scalars['ID'];
  questionFieldId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateNameArgs = {
  name: Scalars['String'];
};


export type MutationUpdateProfileArgs = {
  industryId?: InputMaybe<Scalars['Int']>;
  learnerTrainingUuid: Scalars['ID'];
  regionId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  subordinateRegionIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type MutationUpdateSettingsArgs = {
  auditoryFeedback?: InputMaybe<Scalars['Boolean']>;
  autoPlay?: InputMaybe<Scalars['Boolean']>;
  darkMode?: InputMaybe<Scalars['String']>;
  learnerTrainingUuid: Scalars['ID'];
  locale?: InputMaybe<Scalars['String']>;
  mediumLocale?: InputMaybe<Scalars['String']>;
  playbackSpeed?: InputMaybe<Scalars['Float']>;
  subtitleLocale?: InputMaybe<Scalars['String']>;
  subtitles?: InputMaybe<Scalars['Boolean']>;
  textLocale?: InputMaybe<Scalars['String']>;
  visualFeedback?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateVideoRecordArgs = {
  learnerTrainingUuid: Scalars['ID'];
  sequenceId: Scalars['ID'];
  videoId: Scalars['ID'];
  watchedSeconds: Scalars['Int'];
};

/** Sequence item of type phone */
export type Phone = ItemInterface & {
  __typename?: 'Phone';
  appear?: Maybe<Scalars['Float']>;
  audios?: Maybe<Array<Audio>>;
  body?: Maybe<Scalars['String']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<VideoMedium>>;
};

/** Picture (medium) */
export type Picture = {
  __typename?: 'Picture';
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  mediaUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

/** Policy handbook */
export type Policy = {
  __typename?: 'Policy';
  docType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  policyUrl?: Maybe<Scalars['String']>;
};

/** Sequence item of type popup */
export type Popup = ItemInterface & {
  __typename?: 'Popup';
  appear?: Maybe<Scalars['Float']>;
  audios?: Maybe<Array<Audio>>;
  body?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  disappear?: Maybe<Scalars['Float']>;
  documents?: Maybe<Array<Document>>;
  icon?: Maybe<Scalars['String']>;
  iconType?: Maybe<Scalars['String']>;
  iconValue?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<VideoMedium>>;
};

/** Autogenerated return type of ProcessChatbotMessage. */
export type ProcessChatbotMessagePayload = {
  __typename?: 'ProcessChatbotMessagePayload';
  chatbotChannel?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  /** Returns all Flipper feature flags for the current context */
  featureFlags: Array<Scalars['String']>;
  /** Return details about a learner_training */
  learnerTraining: LearnerTraining;
  /** Returns the logged in learner */
  me: Learner;
  /** Return details about a sequence */
  sequence: Sequence;
};


export type QueryLearnerTrainingArgs = {
  learnerTrainingUuid: Scalars['ID'];
};


export type QuerySequenceArgs = {
  chapterSequenceId: Scalars['ID'];
  learnerTrainingUuid: Scalars['ID'];
};

/** Sequence item of type question */
export type Question = ItemInterface & {
  __typename?: 'Question';
  appear?: Maybe<Scalars['Float']>;
  audios?: Maybe<Array<Audio>>;
  body?: Maybe<Scalars['String']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<QuestionField>>;
  llamaSurvey?: Maybe<Scalars['Boolean']>;
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  variant: Scalars['String'];
  videos?: Maybe<Array<VideoMedium>>;
};

/** Sequence item of type question field (option) used in a question */
export type QuestionField = ItemInterface & {
  __typename?: 'QuestionField';
  appear?: Maybe<Scalars['Float']>;
  correct?: Maybe<Scalars['Boolean']>;
  disappear?: Maybe<Scalars['Float']>;
  feedback?: Maybe<Scalars['String']>;
  feedbackAudios?: Maybe<Array<Audio>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pairId?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  subvalue?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of RecordReviewTime. */
export type RecordReviewTimePayload = {
  __typename?: 'RecordReviewTimePayload';
  errors: Array<Scalars['String']>;
  learnerTraining: LearnerTraining;
};

export type Region = {
  __typename?: 'Region';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of Review. */
export type ReviewPayload = {
  __typename?: 'ReviewPayload';
  errors: Array<Scalars['String']>;
};

export type RichError = {
  __typename?: 'RichError';
  data?: Maybe<Scalars['JSON']>;
  message?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/** Autogenerated return type of SaveAnswers. */
export type SaveAnswersPayload = {
  __typename?: 'SaveAnswersPayload';
  errors: Array<Scalars['String']>;
  learnerTraining?: Maybe<LearnerTraining>;
};

/** Training sequence (slide) */
export type Sequence = {
  __typename?: 'Sequence';
  audios?: Maybe<Array<Audio>>;
  autoContinue?: Maybe<Scalars['Boolean']>;
  duration?: Maybe<Scalars['Int']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  items?: Maybe<Array<ItemInterface>>;
  narration?: Maybe<Scalars['String']>;
  personalization: Scalars['Boolean'];
  playAudio?: Maybe<Scalars['Boolean']>;
  sendRxdInteractions?: Maybe<Scalars['Boolean']>;
  showContinueEndAudio?: Maybe<Scalars['Boolean']>;
  subtitlesUrl?: Maybe<Scalars['String']>;
  templateId?: Maybe<Scalars['ID']>;
  templateName?: Maybe<Scalars['ID']>;
  type: Scalars['String'];
};

/** Sequence item of type tab */
export type Tab = ItemInterface & {
  __typename?: 'Tab';
  appear?: Maybe<Scalars['Float']>;
  audios?: Maybe<Array<Audio>>;
  body?: Maybe<Scalars['String']>;
  disappear?: Maybe<Scalars['Float']>;
  documents?: Maybe<Array<Document>>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  videos?: Maybe<Array<VideoMedium>>;
};

/** Sequence item of type blob of text */
export type Text = ItemInterface & {
  __typename?: 'Text';
  appear?: Maybe<Scalars['Float']>;
  body?: Maybe<Scalars['String']>;
  disappear?: Maybe<Scalars['Float']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pictures?: Maybe<Array<Picture>>;
  position?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

/** Training */
export type Training = {
  __typename?: 'Training';
  chapters?: Maybe<Array<Chapter>>;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  languageAutoDetect?: Maybe<Scalars['Boolean']>;
  mediumLocales?: Maybe<Array<Scalars['String']>>;
  region?: Maybe<Region>;
  role?: Maybe<Scalars['Int']>;
  subtitleLocales?: Maybe<Array<Scalars['String']>>;
  textLocales?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

/** Autogenerated return type of UpdateName. */
export type UpdateNamePayload = {
  __typename?: 'UpdateNamePayload';
  errors: Array<Scalars['String']>;
  learner?: Maybe<Learner>;
};

/** Autogenerated return type of UpdateProfile. */
export type UpdateProfilePayload = {
  __typename?: 'UpdateProfilePayload';
  errors: Array<Scalars['String']>;
  learnerTraining?: Maybe<LearnerTraining>;
};

/** Autogenerated return type of UpdateSettings. */
export type UpdateSettingsPayload = {
  __typename?: 'UpdateSettingsPayload';
  errors: Array<Scalars['String']>;
  learnerTraining?: Maybe<LearnerTraining>;
};

/** Autogenerated return type of UpdateVideoRecord. */
export type UpdateVideoRecordPayload = {
  __typename?: 'UpdateVideoRecordPayload';
  errors: Array<Scalars['String']>;
};

/** Video (medium) */
export type VideoMedium = {
  __typename?: 'VideoMedium';
  autoPlay?: Maybe<Scalars['Boolean']>;
  hlsUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  loop?: Maybe<Scalars['Boolean']>;
  mediaUrl?: Maybe<Scalars['String']>;
  mpegDashUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  snapshotUrl?: Maybe<Scalars['String']>;
  subtitlesUrl?: Maybe<Scalars['String']>;
  videoRecord?: Maybe<LearnerTrainingVideoRecord>;
};

export type AcknowledgePolicyMutationVariables = Exact<{
  policyIds: Array<Scalars['ID']> | Scalars['ID'];
  learnerTrainingUuid: Scalars['ID'];
  signature: Scalars['String'];
}>;


export type AcknowledgePolicyMutation = { __typename?: 'Mutation', acknowledgePolicy?: { __typename?: 'AcknowledgePolicyPayload', errors: Array<string> } | null };

export type CompleteSequenceMutationVariables = Exact<{
  learnerTrainingUuid: Scalars['ID'];
  chapterSequenceId: Scalars['ID'];
}>;


export type CompleteSequenceMutation = { __typename?: 'Mutation', completeChapterSequence?: { __typename?: 'CompleteChapterSequencePayload', errors: Array<string>, richErrors?: Array<{ __typename?: 'RichError', type: string, message?: string | null, data?: any | null }> | null, learnerTraining?: { __typename?: 'LearnerTraining', chapterSequenceId?: string | null, scorePercent?: number | null, lastAttemptScorePercent?: number | null, featureShowCertificate?: boolean | null, certificateUrl?: string | null, featureShowSocialShare?: boolean | null, scorePassingPercent?: number | null, attemptStatus?: string | null, attemptLimit?: number | null, attemptsRemaining?: number | null, remainingDurationInMinutesForCourseTimers?: number | null, remainingDurationInSecondsForCourseTimers?: number | null } | null } | null };

export type MessageChatbotMutationVariables = Exact<{
  id: Scalars['ID'];
  message: Scalars['String'];
}>;


export type MessageChatbotMutation = { __typename?: 'Mutation', messageChatbot?: { __typename?: 'MessageChatbotPayload', errors: Array<string>, chatbotMessages?: Array<{ __typename?: 'ChatbotMessage', createdAt: any, body?: string | null, role?: string | null, id: string }> | null } | null };

export type PostCommentMutationVariables = Exact<{
  learnerTrainingUuid: Scalars['ID'];
  question: Scalars['String'];
  recipient: Scalars['String'];
  chapterSequenceId: Scalars['ID'];
  topic?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
}>;


export type PostCommentMutation = { __typename?: 'Mutation', comment?: { __typename?: 'CommentPayload', errors: Array<string> } | null };

export type PostReviewMutationVariables = Exact<{
  learnerTrainingUuid: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Int']>;
  ratingContent?: InputMaybe<Scalars['Int']>;
  ratingFunctionality?: InputMaybe<Scalars['Int']>;
  ratingEngagement?: InputMaybe<Scalars['Int']>;
}>;


export type PostReviewMutation = { __typename?: 'Mutation', review?: { __typename?: 'ReviewPayload', errors: Array<string> } | null };

export type ProcessChatbotMessageMutationVariables = Exact<{
  learnerTrainingUuid: Scalars['ID'];
  message: Scalars['String'];
}>;


export type ProcessChatbotMessageMutation = { __typename?: 'Mutation', processChatbotMessage?: { __typename?: 'ProcessChatbotMessagePayload', chatbotChannel?: string | null, errors: Array<string>, success: boolean } | null };

export type RecordReviewTimeMutationVariables = Exact<{
  learnerTrainingUuid: Scalars['ID'];
  active: Scalars['Boolean'];
  reset?: InputMaybe<Scalars['Boolean']>;
}>;


export type RecordReviewTimeMutation = { __typename?: 'Mutation', recordReviewTime?: { __typename?: 'RecordReviewTimePayload', errors: Array<string>, learnerTraining: { __typename?: 'LearnerTraining', id: string, remainingDurationInMinutesForCourseTimers?: number | null, remainingDurationInSecondsForCourseTimers?: number | null } } | null };

export type SaveAnswersMutationVariables = Exact<{
  learnerTrainingUuid: Scalars['ID'];
  chapterSequenceId: Scalars['ID'];
  questionFieldId: Scalars['ID'];
}>;


export type SaveAnswersMutation = { __typename?: 'Mutation', saveAnswers?: { __typename?: 'SaveAnswersPayload', errors: Array<string>, learnerTraining?: { __typename?: 'LearnerTraining', mediumLocale?: string | null, textLocale?: string | null, subtitleLocale?: string | null, subtitles?: boolean | null } | null } | null };

export type UpdateVideoRecordMutationVariables = Exact<{
  learnerTrainingUuid: Scalars['ID'];
  sequenceId: Scalars['ID'];
  videoId: Scalars['ID'];
  watchedSeconds: Scalars['Int'];
}>;


export type UpdateVideoRecordMutation = { __typename?: 'Mutation', updateVideoRecord?: { __typename?: 'UpdateVideoRecordPayload', errors: Array<string> } | null };

export type SequenceDetailsQueryVariables = Exact<{
  chapterSequenceId: Scalars['ID'];
  learnerTrainingUuid: Scalars['ID'];
}>;


export type SequenceDetailsQuery = { __typename?: 'Query', sequence: { __typename?: 'Sequence', type: string, templateName?: string | null, icon?: string | null, duration?: number | null, narration?: string | null, subtitlesUrl?: string | null, playAudio?: boolean | null, showContinueEndAudio?: boolean | null, id: string, sendRxdInteractions?: boolean | null, autoContinue?: boolean | null, personalization: boolean, items?: Array<{ __typename?: 'Background', backgroundType?: string | null, mediaOrientation?: string | null, value?: string | null, opacity?: number | null, color?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, audios?: Array<{ __typename?: 'Audio', id: string, loop?: boolean | null, name?: string | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null }> | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null, width?: number | null, height?: number | null }> | null, videos?: Array<{ __typename?: 'VideoMedium', id: string, name?: string | null, loop?: boolean | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, snapshotUrl?: string | null, hlsUrl?: string | null, mpegDashUrl?: string | null, videoRecord?: { __typename?: 'LearnerTrainingVideoRecord', watchedSeconds: number } | null }> | null } | { __typename?: 'Button', id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null } | { __typename?: 'Card', variant?: string | null, title?: string | null, subtitle?: string | null, body?: string | null, branchSequenceId?: string | null, icon?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null }> | null, documents?: Array<{ __typename?: 'Document', id: string, name?: string | null, mediaUrl?: string | null }> | null, audios?: Array<{ __typename?: 'Audio', id: string, name?: string | null, mediaUrl?: string | null, subtitlesUrl?: string | null, autoPlay?: boolean | null, generated: boolean }> | null, videos?: Array<{ __typename?: 'VideoMedium', id: string, name?: string | null, loop?: boolean | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, snapshotUrl?: string | null, hlsUrl?: string | null, mpegDashUrl?: string | null, videoRecord?: { __typename?: 'LearnerTrainingVideoRecord', watchedSeconds: number } | null }> | null, items?: Array<{ __typename?: 'Button', id: string, type?: string | null, title?: string | null, url?: string | null, variant?: string | null }> | null } | { __typename?: 'Carousel', variant?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null } | { __typename?: 'Chart', variant?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null } | { __typename?: 'ChatBot', conversationBotId?: string | null, voiceEnabled?: boolean | null, title?: string | null, subtitle?: string | null, body?: string | null, icon?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null }> | null, audios?: Array<{ __typename?: 'Audio', id: string, loop?: boolean | null, name?: string | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, generated: boolean }> | null, videos?: Array<{ __typename?: 'VideoMedium', id: string, name?: string | null, loop?: boolean | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, snapshotUrl?: string | null, hlsUrl?: string | null, mpegDashUrl?: string | null, videoRecord?: { __typename?: 'LearnerTrainingVideoRecord', watchedSeconds: number } | null }> | null } | { __typename?: 'Door', appear?: number | null, disappear?: number | null, position?: number | null, title?: string | null, id: string, type?: string | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null }> | null, audios?: Array<{ __typename?: 'Audio', id: string, loop?: boolean | null, name?: string | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, generated: boolean }> | null, videos?: Array<{ __typename?: 'VideoMedium', id: string, name?: string | null, loop?: boolean | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, videoRecord?: { __typename?: 'LearnerTrainingVideoRecord', watchedSeconds: number } | null }> | null, items?: Array<{ __typename?: 'Card', variant?: string | null, title?: string | null, subtitle?: string | null, body?: string | null, branchSequenceId?: string | null, icon?: string | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null }> | null, audios?: Array<{ __typename?: 'Audio', id: string, name?: string | null, mediaUrl?: string | null, subtitlesUrl?: string | null, autoPlay?: boolean | null, generated: boolean }> | null, videos?: Array<{ __typename?: 'VideoMedium', id: string, name?: string | null, loop?: boolean | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, snapshotUrl?: string | null, hlsUrl?: string | null, mpegDashUrl?: string | null, videoRecord?: { __typename?: 'LearnerTrainingVideoRecord', watchedSeconds: number } | null }> | null, items?: Array<{ __typename?: 'Button', id: string, type?: string | null, title?: string | null, url?: string | null, variant?: string | null }> | null }> | null } | { __typename?: 'Dropdown', id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null } | { __typename?: 'Email', title?: string | null, body?: string | null, variant?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null }> | null, audios?: Array<{ __typename?: 'Audio', id: string, loop?: boolean | null, name?: string | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, generated: boolean }> | null } | { __typename?: 'FlipCard', variant?: string | null, title?: string | null, subtitle?: string | null, body?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null } | { __typename?: 'ImageMap', hotspotPlacementVersion?: number | null, variant?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null, width?: number | null, height?: number | null }> | null, items?: Array<{ __typename?: 'Popup', title?: string | null, subtitle?: string | null, body?: string | null, coordinates?: string | null, iconType?: string | null, iconValue?: number | null, audios?: Array<{ __typename?: 'Audio', id: string, loop?: boolean | null, name?: string | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, generated: boolean }> | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null }> | null, videos?: Array<{ __typename?: 'VideoMedium', id: string, name?: string | null, loop?: boolean | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, snapshotUrl?: string | null, hlsUrl?: string | null, mpegDashUrl?: string | null, videoRecord?: { __typename?: 'LearnerTrainingVideoRecord', watchedSeconds: number } | null }> | null }> | null } | { __typename?: 'Layout', body?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, items?: Array<{ __typename?: 'Text', id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, variant?: string | null, title?: string | null, subtitle?: string | null, body?: string | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null }> | null }> | null } | { __typename?: 'List', title?: string | null, subtitle?: string | null, variant?: string | null, icon?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, items?: Array<{ __typename?: 'Text', id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, variant?: string | null, title?: string | null, subtitle?: string | null, body?: string | null }> | null } | { __typename?: 'Message', id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null } | { __typename?: 'Phone', title?: string | null, subtitle?: string | null, body?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null }> | null, audios?: Array<{ __typename?: 'Audio', id: string, loop?: boolean | null, name?: string | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, generated: boolean }> | null, videos?: Array<{ __typename?: 'VideoMedium', id: string, name?: string | null, loop?: boolean | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, snapshotUrl?: string | null, hlsUrl?: string | null, mpegDashUrl?: string | null, videoRecord?: { __typename?: 'LearnerTrainingVideoRecord', watchedSeconds: number } | null }> | null } | { __typename?: 'Popup', id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null } | { __typename?: 'Question', llamaSurvey?: boolean | null, title?: string | null, subtitle?: string | null, body?: string | null, icon?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null }> | null, audios?: Array<{ __typename?: 'Audio', autoPlay?: boolean | null, id: string, name?: string | null, mediaUrl?: string | null, subtitlesUrl?: string | null, generated: boolean }> | null, videos?: Array<{ __typename?: 'VideoMedium', id: string, name?: string | null, loop?: boolean | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, snapshotUrl?: string | null, hlsUrl?: string | null, mpegDashUrl?: string | null, videoRecord?: { __typename?: 'LearnerTrainingVideoRecord', watchedSeconds: number } | null }> | null, items?: Array<{ __typename?: 'QuestionField', id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, value?: string | null, subvalue?: string | null, correct?: boolean | null, feedback?: string | null, pairId?: string | null, feedbackAudios?: Array<{ __typename?: 'Audio', mediaUrl?: string | null, subtitlesUrl?: string | null }> | null }> | null } | { __typename?: 'QuestionField', id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null } | { __typename?: 'Tab', title?: string | null, subtitle?: string | null, body?: string | null, icon?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, audios?: Array<{ __typename?: 'Audio', id: string, loop?: boolean | null, name?: string | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, generated: boolean }> | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null }> | null, videos?: Array<{ __typename?: 'VideoMedium', id: string, name?: string | null, loop?: boolean | null, autoPlay?: boolean | null, mediaUrl?: string | null, subtitlesUrl?: string | null, snapshotUrl?: string | null, hlsUrl?: string | null, mpegDashUrl?: string | null, videoRecord?: { __typename?: 'LearnerTrainingVideoRecord', watchedSeconds: number } | null }> | null } | { __typename?: 'Text', title?: string | null, subtitle?: string | null, body?: string | null, variant?: string | null, icon?: string | null, id: string, type?: string | null, appear?: number | null, disappear?: number | null, position?: number | null, pictures?: Array<{ __typename?: 'Picture', id: string, name?: string | null, mediaUrl?: string | null }> | null }> | null } };

export type TrainingInitQueryVariables = Exact<{
  learnerTrainingUuid: Scalars['ID'];
}>;


export type TrainingInitQuery = { __typename?: 'Query', learnerTraining: { __typename?: 'LearnerTraining', id: string, disclaimer?: string | null, chapterSequenceId?: string | null, askName?: boolean | null, certificateUrl?: string | null, learnerPortalUrl?: string | null, subtitles?: boolean | null, textLocale?: string | null, subtitleLocale?: string | null, mediumLocale?: string | null, status: LearnerTrainingStatus, skip?: boolean | null, player?: string | null, progress?: number | null, scorePercent?: number | null, lastAttemptScorePercent?: number | null, scorePassingPercent?: number | null, attemptStatus?: string | null, attemptLimit?: number | null, attemptsRemaining?: number | null, policyAcknowledgement?: boolean | null, policyAcknowledgementSignature?: boolean | null, featureShowHotline?: boolean | null, featureShowReviewStep?: boolean | null, featureShowAbout?: boolean | null, fasterPlaybackSpeed?: boolean | null, featureShowLlama?: boolean | null, featureShowIssueReporting?: boolean | null, featureShowChatbot?: boolean | null, featureFocus?: boolean | null, auditoryFeedback?: boolean | null, visualFeedback?: boolean | null, darkMode?: string | null, autoPlay?: boolean | null, playbackSpeed: number, featureShowCertificate?: boolean | null, featureShowSocialShare?: boolean | null, featureShowNextTraining?: boolean | null, chatGreeting?: string | null, chatQuestions?: Array<string> | null, promptOptions?: any | null, promptProfile?: boolean | null, onboarding?: boolean | null, shouldDisplayCourseDurationCard?: boolean | null, shouldDisplayTimeRemainingPill?: boolean | null, remainingDurationInMinutesForCourseTimers?: number | null, remainingDurationInSecondsForCourseTimers?: number | null, shouldSaveVideoWatchedSeconds?: boolean | null, autoSaveVideoWatchedSecondsIntervalInSeconds?: number | null, featureShowHomeButton?: boolean | null, showDemoBanner?: boolean | null, chatbotMessages?: Array<{ __typename?: 'ChatbotMessage', createdAt: any, body?: string | null, role?: string | null, id: string }> | null, companyContacts?: Array<{ __typename?: 'CompanyContact', name?: string | null, department?: string | null, email?: string | null, phone?: string | null, otherInfo?: string | null }> | null, training: { __typename?: 'Training', title: string, duration?: number | null, mediumLocales?: Array<string> | null, textLocales?: Array<string> | null, subtitleLocales?: Array<string> | null, languageAutoDetect?: boolean | null, region?: { __typename?: 'Region', name?: string | null } | null, chapters?: Array<{ __typename?: 'Chapter', id: string, title: string, position: number, duration: number, chapterSequences: Array<{ __typename?: 'ChapterSequence', id: string, position?: number | null, title?: string | null, duration: number, sequenceId: string, type?: string | null, icon?: string | null }> }> | null }, policies?: Array<{ __typename?: 'Policy', id: string, name?: string | null, policyUrl?: string | null }> | null, policiesForSignature?: Array<{ __typename?: 'Policy', id: string, name?: string | null, policyUrl?: string | null }> | null }, me: { __typename?: 'Learner', firstName?: string | null, lastName?: string | null, company: { __typename?: 'Company', id: string, name?: string | null, logoUrl?: string | null, brandColorDark?: string | null, brandColorLight?: string | null, feedbackUrl?: string | null } } };

export type UpdateNameMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type UpdateNameMutation = { __typename?: 'Mutation', updateName?: { __typename?: 'UpdateNamePayload', errors: Array<string> } | null };

export type UpdateProfileMutationVariables = Exact<{
  learnerTrainingUuid: Scalars['ID'];
  industryId?: InputMaybe<Scalars['Int']>;
  regionId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  subordinateRegionIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'UpdateProfilePayload', errors: Array<string>, learnerTraining?: { __typename?: 'LearnerTraining', id: string, mediumLocale?: string | null, textLocale?: string | null, subtitleLocale?: string | null, subtitles?: boolean | null, auditoryFeedback?: boolean | null, visualFeedback?: boolean | null, darkMode?: string | null, autoPlay?: boolean | null } | null } | null };

export type UpdateSettingsMutationVariables = Exact<{
  learnerTrainingUuid: Scalars['ID'];
  mediumLocale?: InputMaybe<Scalars['String']>;
  textLocale?: InputMaybe<Scalars['String']>;
  subtitleLocale?: InputMaybe<Scalars['String']>;
  subtitles?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  auditoryFeedback?: InputMaybe<Scalars['Boolean']>;
  visualFeedback?: InputMaybe<Scalars['Boolean']>;
  darkMode?: InputMaybe<Scalars['String']>;
  autoPlay?: InputMaybe<Scalars['Boolean']>;
  playbackSpeed?: InputMaybe<Scalars['Float']>;
}>;


export type UpdateSettingsMutation = { __typename?: 'Mutation', updateSettings?: { __typename?: 'UpdateSettingsPayload', errors: Array<string>, learnerTraining?: { __typename?: 'LearnerTraining', disclaimer?: string | null, mediumLocale?: string | null, textLocale?: string | null, subtitleLocale?: string | null, subtitles?: boolean | null, auditoryFeedback?: boolean | null, visualFeedback?: boolean | null, darkMode?: string | null, autoPlay?: boolean | null, playbackSpeed: number } | null } | null };


export const AcknowledgePolicyDocument = gql`
    mutation acknowledgePolicy($policyIds: [ID!]!, $learnerTrainingUuid: ID!, $signature: String!) {
  acknowledgePolicy(
    policyIds: $policyIds
    learnerTrainingUuid: $learnerTrainingUuid
    signature: $signature
  ) {
    errors
  }
}
    `;
export type AcknowledgePolicyMutationFn = Apollo.MutationFunction<AcknowledgePolicyMutation, AcknowledgePolicyMutationVariables>;

/**
 * __useAcknowledgePolicyMutation__
 *
 * To run a mutation, you first call `useAcknowledgePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgePolicyMutation, { data, loading, error }] = useAcknowledgePolicyMutation({
 *   variables: {
 *      policyIds: // value for 'policyIds'
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *      signature: // value for 'signature'
 *   },
 * });
 */
export function useAcknowledgePolicyMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgePolicyMutation, AcknowledgePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgePolicyMutation, AcknowledgePolicyMutationVariables>(AcknowledgePolicyDocument, options);
      }
export type AcknowledgePolicyMutationHookResult = ReturnType<typeof useAcknowledgePolicyMutation>;
export type AcknowledgePolicyMutationResult = Apollo.MutationResult<AcknowledgePolicyMutation>;
export type AcknowledgePolicyMutationOptions = Apollo.BaseMutationOptions<AcknowledgePolicyMutation, AcknowledgePolicyMutationVariables>;
export const CompleteSequenceDocument = gql`
    mutation completeSequence($learnerTrainingUuid: ID!, $chapterSequenceId: ID!) {
  completeChapterSequence(
    learnerTrainingUuid: $learnerTrainingUuid
    chapterSequenceId: $chapterSequenceId
  ) {
    errors
    richErrors {
      type
      message
      data
    }
    learnerTraining {
      chapterSequenceId
      scorePercent
      lastAttemptScorePercent
      featureShowCertificate
      certificateUrl
      featureShowSocialShare
      scorePassingPercent
      attemptStatus
      attemptLimit
      attemptsRemaining
      remainingDurationInMinutesForCourseTimers
      remainingDurationInSecondsForCourseTimers
    }
  }
}
    `;
export type CompleteSequenceMutationFn = Apollo.MutationFunction<CompleteSequenceMutation, CompleteSequenceMutationVariables>;

/**
 * __useCompleteSequenceMutation__
 *
 * To run a mutation, you first call `useCompleteSequenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSequenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSequenceMutation, { data, loading, error }] = useCompleteSequenceMutation({
 *   variables: {
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *      chapterSequenceId: // value for 'chapterSequenceId'
 *   },
 * });
 */
export function useCompleteSequenceMutation(baseOptions?: Apollo.MutationHookOptions<CompleteSequenceMutation, CompleteSequenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteSequenceMutation, CompleteSequenceMutationVariables>(CompleteSequenceDocument, options);
      }
export type CompleteSequenceMutationHookResult = ReturnType<typeof useCompleteSequenceMutation>;
export type CompleteSequenceMutationResult = Apollo.MutationResult<CompleteSequenceMutation>;
export type CompleteSequenceMutationOptions = Apollo.BaseMutationOptions<CompleteSequenceMutation, CompleteSequenceMutationVariables>;
export const MessageChatbotDocument = gql`
    mutation messageChatbot($id: ID!, $message: String!) {
  messageChatbot(id: $id, message: $message) {
    errors
    chatbotMessages {
      createdAt
      body
      role
      id
    }
  }
}
    `;
export type MessageChatbotMutationFn = Apollo.MutationFunction<MessageChatbotMutation, MessageChatbotMutationVariables>;

/**
 * __useMessageChatbotMutation__
 *
 * To run a mutation, you first call `useMessageChatbotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageChatbotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageChatbotMutation, { data, loading, error }] = useMessageChatbotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useMessageChatbotMutation(baseOptions?: Apollo.MutationHookOptions<MessageChatbotMutation, MessageChatbotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MessageChatbotMutation, MessageChatbotMutationVariables>(MessageChatbotDocument, options);
      }
export type MessageChatbotMutationHookResult = ReturnType<typeof useMessageChatbotMutation>;
export type MessageChatbotMutationResult = Apollo.MutationResult<MessageChatbotMutation>;
export type MessageChatbotMutationOptions = Apollo.BaseMutationOptions<MessageChatbotMutation, MessageChatbotMutationVariables>;
export const PostCommentDocument = gql`
    mutation PostComment($learnerTrainingUuid: ID!, $question: String!, $recipient: String!, $chapterSequenceId: ID!, $topic: String, $userAgent: String) {
  comment(
    learnerTrainingUuid: $learnerTrainingUuid
    question: $question
    recipient: $recipient
    chapterSequenceId: $chapterSequenceId
    topic: $topic
    userAgent: $userAgent
  ) {
    errors
  }
}
    `;
export type PostCommentMutationFn = Apollo.MutationFunction<PostCommentMutation, PostCommentMutationVariables>;

/**
 * __usePostCommentMutation__
 *
 * To run a mutation, you first call `usePostCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCommentMutation, { data, loading, error }] = usePostCommentMutation({
 *   variables: {
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *      question: // value for 'question'
 *      recipient: // value for 'recipient'
 *      chapterSequenceId: // value for 'chapterSequenceId'
 *      topic: // value for 'topic'
 *      userAgent: // value for 'userAgent'
 *   },
 * });
 */
export function usePostCommentMutation(baseOptions?: Apollo.MutationHookOptions<PostCommentMutation, PostCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostCommentMutation, PostCommentMutationVariables>(PostCommentDocument, options);
      }
export type PostCommentMutationHookResult = ReturnType<typeof usePostCommentMutation>;
export type PostCommentMutationResult = Apollo.MutationResult<PostCommentMutation>;
export type PostCommentMutationOptions = Apollo.BaseMutationOptions<PostCommentMutation, PostCommentMutationVariables>;
export const PostReviewDocument = gql`
    mutation PostReview($learnerTrainingUuid: ID!, $comment: String, $rating: Int, $ratingContent: Int, $ratingFunctionality: Int, $ratingEngagement: Int) {
  review(
    learnerTrainingUuid: $learnerTrainingUuid
    rating: $rating
    ratingContent: $ratingContent
    ratingFunctionality: $ratingFunctionality
    ratingEngagement: $ratingEngagement
    comment: $comment
  ) {
    errors
  }
}
    `;
export type PostReviewMutationFn = Apollo.MutationFunction<PostReviewMutation, PostReviewMutationVariables>;

/**
 * __usePostReviewMutation__
 *
 * To run a mutation, you first call `usePostReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postReviewMutation, { data, loading, error }] = usePostReviewMutation({
 *   variables: {
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *      comment: // value for 'comment'
 *      rating: // value for 'rating'
 *      ratingContent: // value for 'ratingContent'
 *      ratingFunctionality: // value for 'ratingFunctionality'
 *      ratingEngagement: // value for 'ratingEngagement'
 *   },
 * });
 */
export function usePostReviewMutation(baseOptions?: Apollo.MutationHookOptions<PostReviewMutation, PostReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostReviewMutation, PostReviewMutationVariables>(PostReviewDocument, options);
      }
export type PostReviewMutationHookResult = ReturnType<typeof usePostReviewMutation>;
export type PostReviewMutationResult = Apollo.MutationResult<PostReviewMutation>;
export type PostReviewMutationOptions = Apollo.BaseMutationOptions<PostReviewMutation, PostReviewMutationVariables>;
export const ProcessChatbotMessageDocument = gql`
    mutation ProcessChatbotMessage($learnerTrainingUuid: ID!, $message: String!) {
  processChatbotMessage(
    learnerTrainingUuid: $learnerTrainingUuid
    message: $message
  ) {
    chatbotChannel
    errors
    success
  }
}
    `;
export type ProcessChatbotMessageMutationFn = Apollo.MutationFunction<ProcessChatbotMessageMutation, ProcessChatbotMessageMutationVariables>;

/**
 * __useProcessChatbotMessageMutation__
 *
 * To run a mutation, you first call `useProcessChatbotMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessChatbotMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processChatbotMessageMutation, { data, loading, error }] = useProcessChatbotMessageMutation({
 *   variables: {
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useProcessChatbotMessageMutation(baseOptions?: Apollo.MutationHookOptions<ProcessChatbotMessageMutation, ProcessChatbotMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessChatbotMessageMutation, ProcessChatbotMessageMutationVariables>(ProcessChatbotMessageDocument, options);
      }
export type ProcessChatbotMessageMutationHookResult = ReturnType<typeof useProcessChatbotMessageMutation>;
export type ProcessChatbotMessageMutationResult = Apollo.MutationResult<ProcessChatbotMessageMutation>;
export type ProcessChatbotMessageMutationOptions = Apollo.BaseMutationOptions<ProcessChatbotMessageMutation, ProcessChatbotMessageMutationVariables>;
export const RecordReviewTimeDocument = gql`
    mutation recordReviewTime($learnerTrainingUuid: ID!, $active: Boolean!, $reset: Boolean = false) {
  recordReviewTime(
    learnerTrainingUuid: $learnerTrainingUuid
    active: $active
    reset: $reset
  ) {
    errors
    learnerTraining {
      id
      remainingDurationInMinutesForCourseTimers
      remainingDurationInSecondsForCourseTimers
    }
  }
}
    `;
export type RecordReviewTimeMutationFn = Apollo.MutationFunction<RecordReviewTimeMutation, RecordReviewTimeMutationVariables>;

/**
 * __useRecordReviewTimeMutation__
 *
 * To run a mutation, you first call `useRecordReviewTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordReviewTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordReviewTimeMutation, { data, loading, error }] = useRecordReviewTimeMutation({
 *   variables: {
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *      active: // value for 'active'
 *      reset: // value for 'reset'
 *   },
 * });
 */
export function useRecordReviewTimeMutation(baseOptions?: Apollo.MutationHookOptions<RecordReviewTimeMutation, RecordReviewTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordReviewTimeMutation, RecordReviewTimeMutationVariables>(RecordReviewTimeDocument, options);
      }
export type RecordReviewTimeMutationHookResult = ReturnType<typeof useRecordReviewTimeMutation>;
export type RecordReviewTimeMutationResult = Apollo.MutationResult<RecordReviewTimeMutation>;
export type RecordReviewTimeMutationOptions = Apollo.BaseMutationOptions<RecordReviewTimeMutation, RecordReviewTimeMutationVariables>;
export const SaveAnswersDocument = gql`
    mutation saveAnswers($learnerTrainingUuid: ID!, $chapterSequenceId: ID!, $questionFieldId: ID!) {
  saveAnswers(
    learnerTrainingUuid: $learnerTrainingUuid
    chapterSequenceId: $chapterSequenceId
    questionFieldId: $questionFieldId
  ) {
    errors
    learnerTraining {
      mediumLocale
      textLocale
      subtitleLocale
      subtitles
    }
  }
}
    `;
export type SaveAnswersMutationFn = Apollo.MutationFunction<SaveAnswersMutation, SaveAnswersMutationVariables>;

/**
 * __useSaveAnswersMutation__
 *
 * To run a mutation, you first call `useSaveAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAnswersMutation, { data, loading, error }] = useSaveAnswersMutation({
 *   variables: {
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *      chapterSequenceId: // value for 'chapterSequenceId'
 *      questionFieldId: // value for 'questionFieldId'
 *   },
 * });
 */
export function useSaveAnswersMutation(baseOptions?: Apollo.MutationHookOptions<SaveAnswersMutation, SaveAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAnswersMutation, SaveAnswersMutationVariables>(SaveAnswersDocument, options);
      }
export type SaveAnswersMutationHookResult = ReturnType<typeof useSaveAnswersMutation>;
export type SaveAnswersMutationResult = Apollo.MutationResult<SaveAnswersMutation>;
export type SaveAnswersMutationOptions = Apollo.BaseMutationOptions<SaveAnswersMutation, SaveAnswersMutationVariables>;
export const UpdateVideoRecordDocument = gql`
    mutation updateVideoRecord($learnerTrainingUuid: ID!, $sequenceId: ID!, $videoId: ID!, $watchedSeconds: Int!) {
  updateVideoRecord(
    learnerTrainingUuid: $learnerTrainingUuid
    sequenceId: $sequenceId
    videoId: $videoId
    watchedSeconds: $watchedSeconds
  ) {
    errors
  }
}
    `;
export type UpdateVideoRecordMutationFn = Apollo.MutationFunction<UpdateVideoRecordMutation, UpdateVideoRecordMutationVariables>;

/**
 * __useUpdateVideoRecordMutation__
 *
 * To run a mutation, you first call `useUpdateVideoRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoRecordMutation, { data, loading, error }] = useUpdateVideoRecordMutation({
 *   variables: {
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *      sequenceId: // value for 'sequenceId'
 *      videoId: // value for 'videoId'
 *      watchedSeconds: // value for 'watchedSeconds'
 *   },
 * });
 */
export function useUpdateVideoRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoRecordMutation, UpdateVideoRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoRecordMutation, UpdateVideoRecordMutationVariables>(UpdateVideoRecordDocument, options);
      }
export type UpdateVideoRecordMutationHookResult = ReturnType<typeof useUpdateVideoRecordMutation>;
export type UpdateVideoRecordMutationResult = Apollo.MutationResult<UpdateVideoRecordMutation>;
export type UpdateVideoRecordMutationOptions = Apollo.BaseMutationOptions<UpdateVideoRecordMutation, UpdateVideoRecordMutationVariables>;
export const SequenceDetailsDocument = gql`
    query SequenceDetails($chapterSequenceId: ID!, $learnerTrainingUuid: ID!) {
  sequence(
    chapterSequenceId: $chapterSequenceId
    learnerTrainingUuid: $learnerTrainingUuid
  ) {
    type
    templateName
    icon
    duration
    narration
    subtitlesUrl
    playAudio
    showContinueEndAudio
    id
    sendRxdInteractions
    autoContinue
    personalization
    items {
      id
      type
      appear
      disappear
      position
      ... on Background {
        backgroundType
        mediaOrientation
        value
        opacity
        color
        audios {
          id
          loop
          name
          autoPlay
          mediaUrl
          subtitlesUrl
        }
        pictures {
          id
          name
          mediaUrl
          width
          height
        }
        videos {
          id
          name
          loop
          autoPlay
          mediaUrl
          subtitlesUrl
          snapshotUrl
          hlsUrl
          mpegDashUrl
          videoRecord {
            watchedSeconds
          }
        }
      }
      ... on Card {
        variant
        title
        subtitle
        body
        branchSequenceId
        icon
        pictures {
          id
          name
          mediaUrl
        }
        documents {
          id
          name
          mediaUrl
        }
        audios {
          id
          name
          mediaUrl
          subtitlesUrl
          autoPlay
          generated
        }
        videos {
          id
          name
          loop
          autoPlay
          mediaUrl
          subtitlesUrl
          snapshotUrl
          hlsUrl
          mpegDashUrl
          videoRecord {
            watchedSeconds
          }
        }
        items {
          id
          type
          title
          url
          variant
        }
      }
      ... on Carousel {
        variant
      }
      ... on Chart {
        variant
      }
      ... on Email {
        title
        body
        variant
        pictures {
          id
          name
          mediaUrl
        }
        audios {
          id
          loop
          name
          autoPlay
          mediaUrl
          subtitlesUrl
          generated
        }
      }
      ... on FlipCard {
        variant
        title
        subtitle
        body
      }
      ... on ImageMap {
        hotspotPlacementVersion
        variant
        pictures {
          id
          name
          mediaUrl
          width
          height
        }
        items {
          title
          subtitle
          body
          coordinates
          iconType
          iconValue
          audios {
            id
            loop
            name
            autoPlay
            mediaUrl
            subtitlesUrl
            generated
          }
          pictures {
            id
            name
            mediaUrl
          }
          videos {
            id
            name
            loop
            autoPlay
            mediaUrl
            subtitlesUrl
            snapshotUrl
            hlsUrl
            mpegDashUrl
            videoRecord {
              watchedSeconds
            }
          }
        }
      }
      ... on List {
        title
        subtitle
        variant
        icon
        items {
          id
          type
          appear
          disappear
          position
          variant
          title
          subtitle
          body
        }
      }
      ... on Layout {
        body
        items {
          id
          type
          appear
          disappear
          position
          variant
          title
          subtitle
          body
          pictures {
            id
            name
            mediaUrl
          }
        }
      }
      ... on Question {
        llamaSurvey
        title
        subtitle
        body
        icon
        pictures {
          id
          name
          mediaUrl
        }
        audios {
          autoPlay
          id
          name
          mediaUrl
          subtitlesUrl
          generated
        }
        videos {
          id
          name
          loop
          autoPlay
          mediaUrl
          subtitlesUrl
          snapshotUrl
          hlsUrl
          mpegDashUrl
          videoRecord {
            watchedSeconds
          }
        }
        items {
          id
          type
          appear
          disappear
          position
          value
          subvalue
          correct
          feedback
          feedbackAudios {
            mediaUrl
            subtitlesUrl
          }
          pairId
        }
      }
      ... on Tab {
        title
        subtitle
        body
        icon
        audios {
          id
          loop
          name
          autoPlay
          mediaUrl
          subtitlesUrl
          generated
        }
        pictures {
          id
          name
          mediaUrl
        }
        videos {
          id
          name
          loop
          autoPlay
          mediaUrl
          subtitlesUrl
          snapshotUrl
          hlsUrl
          mpegDashUrl
          videoRecord {
            watchedSeconds
          }
        }
      }
      ... on Text {
        title
        subtitle
        body
        variant
        icon
        pictures {
          id
          name
          mediaUrl
        }
      }
      ... on ChatBot {
        conversationBotId
        voiceEnabled
        title
        subtitle
        body
        icon
        pictures {
          id
          name
          mediaUrl
        }
        audios {
          id
          loop
          name
          autoPlay
          mediaUrl
          subtitlesUrl
          generated
        }
        videos {
          id
          name
          loop
          autoPlay
          mediaUrl
          subtitlesUrl
          snapshotUrl
          hlsUrl
          mpegDashUrl
          videoRecord {
            watchedSeconds
          }
        }
      }
      ... on Email {
        title
        body
        variant
        pictures {
          id
          name
          mediaUrl
        }
        audios {
          id
          loop
          name
          autoPlay
          mediaUrl
          subtitlesUrl
          generated
        }
      }
      ... on Phone {
        title
        subtitle
        body
        pictures {
          id
          name
          mediaUrl
        }
        audios {
          id
          loop
          name
          autoPlay
          mediaUrl
          subtitlesUrl
          generated
        }
        videos {
          id
          name
          loop
          autoPlay
          mediaUrl
          subtitlesUrl
          snapshotUrl
          hlsUrl
          mpegDashUrl
          videoRecord {
            watchedSeconds
          }
        }
      }
      ... on Door {
        appear
        disappear
        position
        title
        pictures {
          id
          name
          mediaUrl
        }
        audios {
          id
          loop
          name
          autoPlay
          mediaUrl
          subtitlesUrl
          generated
        }
        videos {
          id
          name
          loop
          autoPlay
          mediaUrl
          subtitlesUrl
          videoRecord {
            watchedSeconds
          }
        }
        items {
          variant
          title
          subtitle
          body
          branchSequenceId
          icon
          pictures {
            id
            name
            mediaUrl
          }
          audios {
            id
            name
            mediaUrl
            subtitlesUrl
            autoPlay
            generated
          }
          videos {
            id
            name
            loop
            autoPlay
            mediaUrl
            subtitlesUrl
            snapshotUrl
            hlsUrl
            mpegDashUrl
            videoRecord {
              watchedSeconds
            }
          }
          items {
            id
            type
            title
            url
            variant
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSequenceDetailsQuery__
 *
 * To run a query within a React component, call `useSequenceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSequenceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSequenceDetailsQuery({
 *   variables: {
 *      chapterSequenceId: // value for 'chapterSequenceId'
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *   },
 * });
 */
export function useSequenceDetailsQuery(baseOptions: Apollo.QueryHookOptions<SequenceDetailsQuery, SequenceDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SequenceDetailsQuery, SequenceDetailsQueryVariables>(SequenceDetailsDocument, options);
      }
export function useSequenceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SequenceDetailsQuery, SequenceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SequenceDetailsQuery, SequenceDetailsQueryVariables>(SequenceDetailsDocument, options);
        }
export type SequenceDetailsQueryHookResult = ReturnType<typeof useSequenceDetailsQuery>;
export type SequenceDetailsLazyQueryHookResult = ReturnType<typeof useSequenceDetailsLazyQuery>;
export type SequenceDetailsQueryResult = Apollo.QueryResult<SequenceDetailsQuery, SequenceDetailsQueryVariables>;
export const TrainingInitDocument = gql`
    query TrainingInit($learnerTrainingUuid: ID!) {
  learnerTraining(learnerTrainingUuid: $learnerTrainingUuid) {
    id
    disclaimer
    chapterSequenceId
    askName
    certificateUrl
    learnerPortalUrl
    subtitles
    textLocale
    subtitleLocale
    mediumLocale
    status
    skip
    player
    progress
    scorePercent
    lastAttemptScorePercent
    scorePassingPercent
    attemptStatus
    attemptLimit
    attemptsRemaining
    policyAcknowledgement
    policyAcknowledgementSignature
    featureShowHotline
    featureShowReviewStep
    featureShowAbout
    fasterPlaybackSpeed
    featureShowLlama
    featureShowIssueReporting
    featureShowChatbot
    featureFocus
    auditoryFeedback
    visualFeedback
    darkMode
    autoPlay
    playbackSpeed
    featureShowCertificate
    featureShowSocialShare
    featureShowNextTraining
    chatbotMessages {
      createdAt
      body
      role
      id
    }
    chatGreeting
    chatQuestions
    promptOptions
    promptProfile
    companyContacts {
      name
      department
      email
      phone
      otherInfo
    }
    training {
      title
      duration
      region {
        name
      }
      mediumLocales
      textLocales
      subtitleLocales
      languageAutoDetect
      chapters {
        id
        title
        position
        duration
        chapterSequences {
          id
          position
          title
          duration
          sequenceId
          type
          icon
        }
      }
    }
    policies {
      id
      name
      policyUrl
    }
    policiesForSignature {
      id
      name
      policyUrl
    }
    onboarding
    shouldDisplayCourseDurationCard
    shouldDisplayTimeRemainingPill
    remainingDurationInMinutesForCourseTimers
    remainingDurationInSecondsForCourseTimers
    shouldSaveVideoWatchedSeconds
    autoSaveVideoWatchedSecondsIntervalInSeconds
    featureShowHomeButton
    showDemoBanner
  }
  me {
    firstName
    lastName
    company {
      id
      name
      logoUrl
      brandColorDark
      brandColorLight
      feedbackUrl
    }
  }
}
    `;

/**
 * __useTrainingInitQuery__
 *
 * To run a query within a React component, call `useTrainingInitQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingInitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingInitQuery({
 *   variables: {
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *   },
 * });
 */
export function useTrainingInitQuery(baseOptions: Apollo.QueryHookOptions<TrainingInitQuery, TrainingInitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingInitQuery, TrainingInitQueryVariables>(TrainingInitDocument, options);
      }
export function useTrainingInitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingInitQuery, TrainingInitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingInitQuery, TrainingInitQueryVariables>(TrainingInitDocument, options);
        }
export type TrainingInitQueryHookResult = ReturnType<typeof useTrainingInitQuery>;
export type TrainingInitLazyQueryHookResult = ReturnType<typeof useTrainingInitLazyQuery>;
export type TrainingInitQueryResult = Apollo.QueryResult<TrainingInitQuery, TrainingInitQueryVariables>;
export const UpdateNameDocument = gql`
    mutation updateName($name: String!) {
  updateName(name: $name) {
    errors
  }
}
    `;
export type UpdateNameMutationFn = Apollo.MutationFunction<UpdateNameMutation, UpdateNameMutationVariables>;

/**
 * __useUpdateNameMutation__
 *
 * To run a mutation, you first call `useUpdateNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNameMutation, { data, loading, error }] = useUpdateNameMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNameMutation, UpdateNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNameMutation, UpdateNameMutationVariables>(UpdateNameDocument, options);
      }
export type UpdateNameMutationHookResult = ReturnType<typeof useUpdateNameMutation>;
export type UpdateNameMutationResult = Apollo.MutationResult<UpdateNameMutation>;
export type UpdateNameMutationOptions = Apollo.BaseMutationOptions<UpdateNameMutation, UpdateNameMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation updateProfile($learnerTrainingUuid: ID!, $industryId: Int, $regionId: Int, $role: String, $subordinateRegionIds: [Int!]) {
  updateProfile(
    learnerTrainingUuid: $learnerTrainingUuid
    industryId: $industryId
    regionId: $regionId
    role: $role
    subordinateRegionIds: $subordinateRegionIds
  ) {
    errors
    learnerTraining {
      id
      mediumLocale
      textLocale
      subtitleLocale
      subtitles
      auditoryFeedback
      visualFeedback
      darkMode
      autoPlay
    }
  }
}
    `;
export type UpdateProfileMutationFn = Apollo.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *      industryId: // value for 'industryId'
 *      regionId: // value for 'regionId'
 *      role: // value for 'role'
 *      subordinateRegionIds: // value for 'subordinateRegionIds'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, options);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = Apollo.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const UpdateSettingsDocument = gql`
    mutation updateSettings($learnerTrainingUuid: ID!, $mediumLocale: String, $textLocale: String, $subtitleLocale: String, $subtitles: Boolean, $locale: String, $auditoryFeedback: Boolean, $visualFeedback: Boolean, $darkMode: String, $autoPlay: Boolean, $playbackSpeed: Float) {
  updateSettings(
    learnerTrainingUuid: $learnerTrainingUuid
    mediumLocale: $mediumLocale
    textLocale: $textLocale
    subtitleLocale: $subtitleLocale
    subtitles: $subtitles
    locale: $locale
    auditoryFeedback: $auditoryFeedback
    visualFeedback: $visualFeedback
    darkMode: $darkMode
    autoPlay: $autoPlay
    playbackSpeed: $playbackSpeed
  ) {
    errors
    learnerTraining {
      disclaimer
      mediumLocale
      textLocale
      subtitleLocale
      subtitles
      auditoryFeedback
      visualFeedback
      darkMode
      autoPlay
      playbackSpeed
    }
  }
}
    `;
export type UpdateSettingsMutationFn = Apollo.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>;

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      learnerTrainingUuid: // value for 'learnerTrainingUuid'
 *      mediumLocale: // value for 'mediumLocale'
 *      textLocale: // value for 'textLocale'
 *      subtitleLocale: // value for 'subtitleLocale'
 *      subtitles: // value for 'subtitles'
 *      locale: // value for 'locale'
 *      auditoryFeedback: // value for 'auditoryFeedback'
 *      visualFeedback: // value for 'visualFeedback'
 *      darkMode: // value for 'darkMode'
 *      autoPlay: // value for 'autoPlay'
 *      playbackSpeed: // value for 'playbackSpeed'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, options);
      }
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = Apollo.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;